import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { AppContext } from "../context/AppContext";
import { auth } from "../services/firebase";
import { signOut } from "firebase/auth";
import "./Navbar.css"; // Importa o CSS

function Navbar() {
  const navigate = useNavigate();
  const { setIsOpenLogin } = useContext(AppContext);

  function LogOut() {
    console.log(`LogOut`);
    
    // Encerra a sessão do Firebase
    signOut(auth);

    // Fecha o overlay de login (caso esteja aberto)
    setIsOpenLogin(false);

    // Redireciona para a home
    navigate("/");
  }

  return (
    <nav className="navbar">
    <div className="navbar-links">
      <Link to="/" className="navbar-link">Home</Link>
      <Link to="/games" className="navbar-link">Games</Link>
      {/* <Link to="/chat" className="navbar-link">Chat</Link> */}
      <Link to="/about" className="navbar-link">About</Link> {/* <--- ADICIONE ISSO */}
    </div>
      
      <button className="logout-btn" onClick={LogOut}>
        Logout
      </button>
    </nav>
  );
}

export default Navbar;